import {  createAsyncThunk } from '@reduxjs/toolkit';
import {API} from '../../axios/instance'

// Async thunk to fetch contacts (server-side filtering/search)
export const fetchContacts = createAsyncThunk('contacts/fetchContacts', async (params = {}, { getState }) => {
    const { page, limit, search, contactType, label, userId: paramUserId, businessId } = params || {};
    const state = typeof getState === 'function' ? getState() : undefined;
    const auth = state?.auth;
    const decodeJwt = (token) => {
        try {
            if (!token) return null;
            const base64Url = token.split('.')[1];
            if (!base64Url) return null;
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            if (typeof atob !== 'function') return null;
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            return JSON.parse(jsonPayload);
        } catch {
            return null;
        }
    };
    const token = typeof window !== 'undefined' ? window.localStorage?.getItem('accessToken') : null;
    const tokenUser = token ? decodeJwt(token) : null;
    const derivedUserId =
        paramUserId ||
        auth?.userData?.user?.id ||
        auth?.userData?.user?._id ||
        auth?.userData?.userId ||
        auth?.userData?._id ||
        auth?.userId ||
        tokenUser?.userId ||
        null;

    const response = await API.get('contact/contact', {
        params: {
            // page and limit reserved for potential server-side pagination
            ...(page ? { page } : {}),
            ...(limit ? { limit } : {}),
            ...(search ? { search } : {}),
            ...(contactType ? { contactType } : {}),
            ...(label ? { label } : {}),
            ...(derivedUserId ? { userId: derivedUserId } : {}),
            ...(businessId ? { businessId } : {}),
        }
    });
    return response.data?.items || response.data;
});


// Async thunk to create a new contact
export const createContact = createAsyncThunk('contacts/createContact', async (payload) => {
    const response = await API.post('contact/contact/create-contact', payload); // Assuming the API endpoint for creating a contact
    return response.data;
});


// Async thunk to fetch a single contact by ID
export const fetchContactById = createAsyncThunk('contacts/fetchContactById', async (contactId) => {
    const response = await API.get(`contact/contact/${contactId}`); // Assuming the endpoint requires `contactId` in the URL
    return response.data;
});

// Async thunk to update a contact
export const updateContact = createAsyncThunk('contacts/updateContact', async (payload) => {
    const { _id, updatedData, note } = payload; // Expecting id, updated fields, and optional note
    const body = { ...updatedData };
    if (note && String(note).trim() !== '') body.note = note;
    const response = await API.put(`contact/contact/${_id}`, body);
    return response.data;
});

// Async thunk to delete a contact
export const deleteContact = createAsyncThunk('contacts/deleteContact', async (contactId) => {
    const response = await API.delete(`contact/contact/${contactId}`); // Assuming the endpoint requires `contactId`
    return response.data;
});
